import React, { useState, useEffect } from "react";
import Layout from "../../../components/molecules/Layout";
import "./faqs.css";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AppBar,
  Box,
  Button,
  Popover,
  Tab,
  Tabs,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { useLocation } from "react-router-dom";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`custom-tabpanel-${index}`}
      aria-labelledby={`custom-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function allyProps(index) {
  return {
    id: `custom-tab-${index}`,
    "aria-controls": `custom-tabpanel-${index}`,
  };
}

const Faqs = () => {
  const [value, setValue] = useState(0);
  const handleChange = (e, newValue) => {
    setValue(newValue);
  };
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);
  const [pageTab, setPageTab] = useState(0);
  const faqData = {
    Foreclosure: {
      "Before the Auction": [
        {
          ques: "How do I find properties scheduled for foreclosure/trustee auction?",
          ans: `Properties are listed in public records, auction platforms, and sometimes on county websites. Auction schedules and property details are typically available a few days before the auction.`,
        },
        {
          ques: "What do I need to bring to the auction?",
          ans: `Valid government-issued ID, certified funds (cashier's checks or cash) for the deposit and/or full payment, and proof of funds documentation.`,
        },
        {
          ques: "Can I inspect the property before the auction?",
          ans: `Most foreclosure properties are sold as-is, and access for inspection is rarely granted. Buyers should research property condition through public records or drive-by assessments.`,
        },
        {
          ques: "Is there a Buyer's Premium added to the high bid for a foreclosure/trustee auction?",
          ans: `No. A Buyer's Premium is not added to any foreclosure/trustee sale.`,
        },
        {
          ques: "How should I prepare financially?",
          ans: `Ensure you have sufficient certified funds to cover the deposit and/or full purchase price. Some buyers bring multiple cashier's checks in various denominations for flexibility.`,
        },
        {
          ques: "How do I research the property's title and liens?",
          ans: `Conduct a title search to check for outstanding liens, unpaid taxes, or other claims. Consider hiring a title company or attorney for thorough due diligence.`,
        },
        {
          ques: "Can I finance the purchase?",
          ans: `Almost all foreclosure auctions require cash payment, financing is rarely allowed because of the quick closing timelines and as-is nature of the sale.`,
        },
        {
          ques: "Should I try to contact the current owner before the auction?",
          ans: `Reaching out to the owner may provide valuable information about the property's condition or occupancy status, but access is not guaranteed.`,
        },
        {
          ques: "Are all foreclosure sales in person?",
          ans: `Most states still conduct foreclosure auctions in person, but online bidding is now permitted in some areas. Review the property details page for the most accurate and up-to-date information about how to participate in a specific sale.`,
        },
      ],
      "During the Auction": [
        {
          ques: "How does the bidding process work?",
          ans: `Auctions are typically public, either in person or online. Bidding starts at an opening amount, and you must be ready to bid with no do-overs.`,
        },
        {
          ques: "Do I need to register for the auction?",
          ans: `Registration requirements vary. Some auctions require advance registration, while others do not, but you will always need to provide proof of funds before bidding.`,
        },
        {
          ques: "How and when do I pay if I win?",
          ans: `Payment requirements vary by state and auction. You may need to pay the full amount immediately or a deposit on the spot, with the balance due within a specified period (often 24 hours or up to 30 days).`,
        },
        {
          ques: "What happens if I can’t pay the full amount on time?",
          ans: `If you fail to pay as required, you forfeit your deposit, and the next highest bidder may be offered the property.`,
        },
        {
          ques: "Can I bid on behalf of someone else?",
          ans: `Some auctions allow proxy bidding or bidding on behalf of another party, but you must have proper authorization and documentation.`,
        },
        {
          ques: "Should I bid at the start or wait until later in the auction?",
          ans: `Strategies vary. Some experienced bidders wait until later rounds to avoid driving up the price too early.`,
        },
        {
          ques: "What if the property doesn’t sell at auction?",
          ans: `If no bids meet the minimum, the property reverts to the lender and may be listed as an REO (Real Estate Owned) property.`,
        },
      ],
      "Post Auction": [
        {
          ques: "What documentation do I receive after winning?",
          ans: `You'll receive a certificate of sale or receipt immediately. The official deed (such as a trustee's deed) is issued after any redemption period expires, and the sale is finalized.`,
        },
        {
          ques: "When do I get ownership of the property?",
          ans: `Ownership is transferred after the deed is recorded, which can take 30-45 days. In some states, there may be a redemption period during which the original owner can reclaim the property by paying the debt.`,
        },
        {
          ques: "What if the property is still occupied?",
          ans: `You are responsible for obtaining possession, which may require a formal eviction process according to local laws. No keys are provided at auction.`,
        },
        {
          ques: "Are there additional costs or liens?",
          ans: `You may be responsible for certain liens or unpaid taxes not cleared by the auction. Research title and lien status before bidding.`,
        },
        {
          ques: "What should I do after taking possession?",
          ans: `Inspect the property, address any repairs, and resolve any occupancy or lien issues. Budget for renovations as needed.`,
        },
        {
          ques: "Can I get insurance on the property after purchase?",
          ans: `Some foreclosed properties may not be insurable due to their condition. Secure insurance as soon as possible, but be prepared for potential challenges.`,
        },
        {
          ques: "How soon can I resell or rent out the property?",
          ans: `Once you have clear title and possession, you can resell or rent the property, subject to local laws and any required repairs.`,
        },
        {
          ques: "What if I discover undisclosed damage or issues?",
          ans: `Properties are sold as-is, so any post-sale issues are the buyer’s responsibility. There is no recourse against the seller.`,
        },
        {
          ques: "How do I record the deed and finalize ownership?",
          ans: `File the deed with the county recorder’s office to officially transfer ownership. Consult local requirements for proper recording procedures.`,
        },
      ],
    },

    "Bank Owned": {
      "Before the Auction": [
        {
          ques: "Who determines the starting bid?",
          ans: `Our auction team determines the starting bid based on established formulas. These formulas consider the list price, reserve price, previous bid amounts, and the property's geographic location to arrive at a starting bid below the reserve price.`,
        },
        {
          ques: "How do I view a property before bidding?",
          ans: `If the property is vacant and has a listing agent assigned, you can request to view the property. The agent's contact information is on the property's detail page. To view a property, please get in touch with the listing agent. Please note that if a property is occupied, it cannot be accessed or viewed. Pay attention if a property's detail page states that it cannot be accessed or viewed. If the property is vacant and the seller has added a lockbox, the listing agent may give the lockbox code to a bidder's real estate agent. Only a licensed real estate agent can request the lockbox code and help you gain entry to view the property.`,
        },
        {
          ques: "What does it mean if an online auction property is occupied? Can view the property?",
          ans: `Trespassing on any property, if it is occupied, is illegal, so there is no way to view it. A property being occupied is one reason sellers may ask for "Cash Only" offers, as a lender would require an inspection and appraisal, which are impossible if the property is occupied.`,
        },
        {
          ques: "How do I conduct due diligence on a property prior to placing a bid?",
          ans: `Conducting due diligence involves estimating the value of a property, assessing renovation costs, inspecting the physical property, obtaining a title report, and researching the surrounding neighborhood. If the property is vacant, you should visit to assess items needing repairs before the auction.`,
        },
        {
          ques: "What is the Reserve Price?",
          ans: `The Reserve Price is the minimum amount accepted by a seller. Most properties have an established Reserve Price, although there are occasions when a winning bidder can be declared even if the Reserve Price is not met. This occurs when a property is sold "subject to" the seller's approval. Sometimes, sellers sell a property for less than the Reserve Price.`,
        },
        {
          ques: "Is there a Buyer's Premium added to the high bid for an online bank-owned auction?",
          ans: `Most of the auctions we list include an auction fee that is paid by the Seller. In many cases, there is no Buyer's Premium added to the high bid. However, the property details page will specifically state whether a Buyer's Premium applies or not. Always review the terms listed for each auction before placing a bid.`,
        },
        {
          ques: "Are there any contingencies?",
          ans: `There are no inspection, financing, or appraisal contingencies.`,
        },
        {
          ques: "Is the Opening Bid also the Reserve?",
          ans: `The Opening Bid represents where the bidding will kick off. However, it does not signify the Reserve and might not align with what a Seller is willing to accept as an offer.`,
        },
        {
          ques: "What percentage of commission is offered to real estate professionals?",
          ans: `Commissions vary from property to property. Check the property details page for details.`,
        },
      ],
      "During the Auction": [
        {
          ques: "Can I make a pre-auction offer?",
          ans: `Currently, the Seller only accepts offers placed as bids through the auction process.`,
        },
        {
          ques: "How do I know if I'm outbid in an online auction?",
          ans: `If you are outbid for a property, you should receive an email notification indicating that you have been outbid. In addition, you can always look at the property's details page or your bidding screens to see if you are the current high bidder.`,
        },
        {
          ques: "Can I place a bid as time is expiring?",
          ans: `To ensure fairness, our system automatically extends the auction ending time by three minutes any time the bid price is raised with less than five minutes remaining. This helps eliminate last-second bidders who attempt to snipe the bids.`,
        },
        {
          ques: "What Is Anti-Snipe Feature?",
          ans: `Bid Extension Feature or Anti-Sniping Functionality. A bid extension feature, also known as anti-sniping, extends the closing time of an auction when a bid is placed in the last few minutes. The goal is to give other bidders time to place a higher bid before the auction ends. The process continues until no more bids are placed within the specified time, and then the auction closes.`,
        },
      ],
      "Post Auction": [
        {
          ques: "How is the title conveyed?",
          ans: `Title will be conveyed to the buyer via Quitclaim Deed or its equivalent and with no express or implied warranties of title. The buyer may purchase title insurance at their own cost.`,
        },
        {
          ques: "What are the costs involved with purchasing an online auction property?",
          ans: `When you successfully win an online auction property on NextDoorAuctions.com, please remember that you will need to cover the final bid amount and all applicable closing costs, dues, transfer taxes, and fees, including title insurance. Conducting thorough due diligence on any potential purchase is crucial to understand the possible liabilities that may persist after the foreclosure process.`,
        },
        {
          ques: "Can I finance a transaction if purchased on NextDoorAuctions.com?",
          ans: `Many of our properties are eligible for financing. However, it's important to note that there are no financing contingencies, so bidders must have their financing in place before placing a bid for an online property. There are also no appraisal contingencies. Additionally, some properties may not allow or provide access for inspections required for financing, which may disqualify them from being financed.`,
        },
        {
          ques: "What happens if I am the highest bidder but the reserve isn't met?",
          ans: `The seller may choose to negotiate with bidders even if the reserve price isn't met. The high bidder will be allowed to submit their highest and best bid for consideration.`,
        },
        {
          ques: "Do I need to provide proof of funds or a pre-qualification letter?",
          ans: `Yes, if you are the high bidder on a property, you'll need to show proof of funds or pre-qualification documents.`,
        },
        {
          ques: "Will the Seller turn on the utilities before closing?",
          ans: `The utilities for all our properties are currently disconnected. Regardless of inspections or appraisals, utilities cannot be turned on prior to closing. The buyer is responsible for utility transfer post-closing.`,
        },
        {
          ques: "Can I purchase a property as a separate entity?",
          ans: `Yes, you can purchase the property as a separate entity, such as a Limited Liability Company or a Trust, but you'll have to provide specific documentation.`,
        },
        {
          ques: "What happens after the auction?",
          ans: `If the Seller accepts the final bid amount, the high bidder will receive an email with a digital questionnaire that must be filled out so that we can create the purchase contract. The required information includes the buyer's and agent's contact information and the source of funds.`,
        },
      ],
      "Just for Agents": [
        {
          ques: "Does NextDoorAuctions.com assign listing agents to online auction properties?",
          ans: `No, agents are assigned by the Seller when they are referred to NextDoorAuctions.com.`,
        },
        {
          ques: "As a licensed Real Estate Agent, will I be compensated if my buyer wins an online auction properties?",
          ans: `Not all properties offer a buyer's agent commission. If a commission is available, it will be clearly stated on the property's details page and included in the purchase contract. In those cases, the commission will be paid by the auction company at closing, based on the terms outlined in the listing.`,
        },
      ],
    },
  };

  return (
    <Layout>
      <div className="faqAlign">
        {/* Page-level Tabs */}
        <div style={{ maxWidth: "900px", margin: "auto" }}>
          <AppBar position="static" color="default">
            <Tabs
              value={pageTab}
              onChange={(e, newValue) => setPageTab(newValue)}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="main page tabs"
            >
              <Tab label="Foreclosure" {...allyProps(0)} />
              <Tab label="Bank Owned" {...allyProps(1)} />
            </Tabs>
          </AppBar>
        </div>

        {/* Foreclosure FAQs */}
        {pageTab === 0 && (
          <>
            <div>
              <p className="text-center descing mb-5">
                Welcome to our{" "}
                <b style={{ color: "black" }}>Frequently Asked Questions</b>{" "}
                page! Here, you'll find helpful guidance to seamlessly navigate
                through the entire auction process, whether you're a first-timer
                or a seasoned bidder. Explore our sections on what to expect
                before, during, and after the auction to ensure you're fully
                prepared and can make the most of your experience. We're here to
                help you every step of the way!
              </p>
            </div>
            <h1 className="text-center">Foreclosure Auctions</h1>

            <section className="allFaqTypes">
              <Tabs value={value} onChange={handleChange} aria-label="faqTabs">
                {Object.keys(faqData.Foreclosure).map((key, index) => (
                  <Tab label={key} {...allyProps(index)} key={index} />
                ))}
              </Tabs>
              <Box>
                {Object.keys(faqData.Foreclosure).map((key, index) => (
                  <CustomTabPanel value={value} index={index} key={index}>
                    {faqData.Foreclosure[key].map((content, contentIndex) => (
                      <Accordion key={contentIndex}>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          aria-controls={`panel${index}-content`}
                          id={`panel${index}-header`}
                        >
                          {content.ques}
                        </AccordionSummary>
                        <AccordionDetails>{content.ans}</AccordionDetails>
                      </Accordion>
                    ))}
                  </CustomTabPanel>
                ))}
              </Box>
            </section>
          </>
        )}

        {/* Bank Owned FAQs */}
        {pageTab === 1 && (
          <>
            <p className="text-center descing mb-5">
              Welcome to our{" "}
              <b style={{ color: "black" }}>Frequently Asked Questions</b> page!
              Here, you'll find helpful guidance to seamlessly navigate through
              the entire auction process, whether you're a first-timer or a
              seasoned bidder. Explore our sections on what to expect before,
              during, and after the auction to ensure you're fully prepared and
              can make the most of your experience. We're here to help you every
              step of the way!
            </p>
            <h1 className="text-center">Bank-Owned Properties</h1>

            <section className="allFaqTypes">
              <Tabs value={value} onChange={handleChange} aria-label="faqTabs">
                {Object.keys(faqData["Bank Owned"]).map((key, index) => (
                  <Tab label={key} {...allyProps(index)} key={index} />
                ))}
              </Tabs>
              <Box>
                {Object.keys(faqData["Bank Owned"]).map((key, index) => (
                  <CustomTabPanel value={value} index={index} key={index}>
                    {faqData["Bank Owned"][key].map((content, contentIndex) => (
                      <Accordion key={contentIndex}>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          aria-controls={`panel${index}-content`}
                          id={`panel${index}-header`}
                        >
                          {content.ques}
                        </AccordionSummary>
                        <AccordionDetails>{content.ans}</AccordionDetails>
                      </Accordion>
                    ))}
                  </CustomTabPanel>
                ))}
              </Box>
            </section>
          </>
        )}
      </div>
    </Layout>
  );
};

export default Faqs;
